(ns app.front.view.group.admin.property.config.attributes
  (:require [app.domain.group.model :as group-model]
            [app.domain.property.model :as property-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.placeholder-button :as ui-placeholder-button]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag]]
            [app.front.view.admin.gis.search-config :as gis-search-config]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::init-new-template
  (fn [{:keys [db]} [_ group-id fetch-sample?]]
    (p/assoc-if {:db (assoc-in db [::data ::new-template] {})}
                :dispatch (when fetch-sample?
                            [::fetch-sample-gis-records group-id false]))))

(rf/reg-event-db ::cancel-new-template
  (fn [db _]
    (p/dissoc-in db [::data ::new-template])))

(rf/reg-event-db ::set-new-template-val
  (fn [db [_ k v]]
    (assoc-in db [::data ::new-template k] v)))

(rf/reg-event-db ::set-reordering
  (fn [db [_ reordering?]]
    (assoc-in db [::data ::reordering?] reordering?)))

(rf/reg-event-fx ::create-new-template
  (fn [_ [_ group-id data]]
    {:comm/command {:command    :group/create-property-attribute-template
                    :data       (assoc data :group-id group-id)
                    :on-success [::create-new-template.success]
                    :notify     {:success :property-mgmt-config.attrs/new-template-created}}}))

(rf/reg-event-fx ::create-new-template.success
  (fn [_ [_ status response]]
    {:fx [[:dispatch [::entities/apply-changes status response]]
          [:dispatch [::cancel-new-template]]]}))

(rf/reg-event-fx ::save-template-edit
  (fn [_ [_ template-id data]]
    {:dispatch [:comm/command-monitored {:command    :group/edit-property-attribute-template
                                         :data       (assoc data :template-id template-id)
                                         :on-success [::save-template-edit.success template-id]
                                         :notify     {:success :changes-saved}}]}))

(rf/reg-event-fx ::save-template-edit.success
  (fn [_ [_ id status response]]
    {:fx [[:dispatch [::entities/apply-changes status response]]
          [:dispatch [::ee/cancel-changes id]]]}))

(rf/reg-event-fx ::remove-template
  (fn [_ [_ template-id]]
    {:comm/command {:command    :group/remove-property-attribute-template
                    :data       {:template-id template-id}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :property-mgmt-config.attrs/template-removed}}}))

(rf/reg-event-fx ::reorder-template
  (fn [_ [_ from to]]
    {:comm/command {:command    :group/reorder-property-attribute-template
                    :data       {:template-id    from
                                 :to-template-id to}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-db ::set-select-option-values
  (fn [db [_ template-id option-id v]]
    (assoc-in db [::data ::select-option template-id option-id] v)))

(rf/reg-event-fx ::create-new-template-option
  (fn [_ [_ template-id data]]
    {:comm/command {:command    :group/create-property-attribute-template-option
                    :data       (assoc data :template-id template-id)
                    :on-success [::template-option.request.success template-id :new]
                    :notify     {:success :property-mgmt-config.attrs/new-option-added}}}))

(rf/reg-event-fx ::template-option.request.success
  (fn [_ [_ template-id template-option-id status response]]
    {:fx [[:dispatch [::entities/apply-changes status response]]
          [:dispatch [::set-select-option-values template-id template-option-id nil]]]}))

(rf/reg-event-fx ::edit-template-option
  (fn [_ [_ template-id template-option-id data]]
    {:comm/command {:command    :group/edit-property-attribute-template-option
                    :data       (assoc data :template-option-id template-option-id)
                    :on-success [::template-option.request.success template-id template-option-id]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::remove-template-option
  (fn [_ [_ template-id template-option-id]]
    {:comm/command {:command    :group/remove-property-attribute-template-option
                    :data       {:template-option-id template-option-id}
                    :on-success [::template-option.request.success template-id template-option-id]
                    :notify     {:success :property-mgmt-config.attrs/option-removed}}}))

(rf/reg-event-fx ::reorder-template-option
  (fn [_ [_ template-id from to]]
    {:comm/command {:command    :group/reorder-property-attribute-template-option
                    :data       (util/mmap template-id from to)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::set-group-attribute-value
  (fn [_ [_ template-id attribute authority-group-id add?]]
    {:comm/command {:command    :group/set-attribute-template-group-attribute
                    :data       (util/mmap template-id attribute authority-group-id add?)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::set-attribute-value
  (fn [_ [_ template-id attribute value]]
    {:comm/command {:command    :group/set-attribute-template-attribute
                    :data       (util/mmap {attribute value}
                                           template-id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::fetch-template-settings
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/property-attribute-template-settings
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::fetch-template-settings.success]}}))

(rf/reg-event-db ::fetch-template-settings.success
  (fn [db [_ _ {:keys [gis-attribute-link-supported?]}]]
    (assoc-in db [::data ::gis-attribute-link-supported?] gis-attribute-link-supported?)))

(rf/reg-event-fx ::fetch-sample-gis-records
  (fn [{:keys [db]} [_ group-id open-modal? coordinates]]
    {:comm/command {:command    :group/get-sample-gis-records
                    :data       (p/assoc-if {:group-id group-id}
                                            :coordinates coordinates)
                    :on-success [::fetch-sample-gis-records.success open-modal?]}
     :db           (assoc-in db [::data ::gis-sample-loading?] true)}))

(rf/reg-event-db ::fetch-sample-gis-records.success
  (fn [db [_ open-modal? _ records]]
    (cond-> (-> (assoc-in db [::data ::sample-gis-records] records)
                (p/dissoc-in [::data ::gis-sample-loading?]))
      open-modal? (assoc-in [::data ::sample-modal-open?] true))))

(rf/reg-event-db ::set-sample-modal-open?
  (fn [db [_ open?]]
    (assoc-in db [::data ::sample-modal-open?] open?)))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::new-template-data
  :<- [::data]
  :-> ::new-template)

(rf/reg-sub ::attribute-templates
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] _]
    (->> (entities/find-entities ctx {:property-attribute-template/group group-id})
         (sort-by :ordered/order))))

(rf/reg-sub ::select-option-values
  :<- [::data]
  (fn [data [_ template-id option-id]]
    (get-in data [::select-option template-id option-id])))

(rf/reg-sub ::reordering?
  :<- [::data]
  :-> ::reordering?)

(rf/reg-sub ::authority-group-ids+pts
  :<- [::gas/group]
  :<- [:tr]
  (fn [[group tr]]
    (->> (group-model/descendant-authority-groups group)
         (map (fn [ag]
                {:db/id       (:db/id ag)
                 :permit-type (some-> (group-model/primary-permit-type ag) vector tr)}))
         (sort-by :permit-type))))

(rf/reg-sub ::gis-attribute-link-supported?
  :<- [::data]
  :<- [::ff/enabled? :feature-flag.id/property-attributes-gis-link]
  (fn [[data feature-enabled?] _]
    (and feature-enabled?
         (::gis-attribute-link-supported? data))))

(rf/reg-sub ::gis-sample-loading?
  :<- [::data]
  :-> ::gis-sample-loading?)

(rf/reg-sub ::sample-gis-records
  :<- [::data]
  :-> ::sample-gis-records)

(rf/reg-sub ::sample-modal-open?
  :<- [::data]
  :-> ::sample-modal-open?)

(rf/reg-sub ::available-gis-attributes
  :<- [::data]
  (fn [data _]
    (some->> data
             ::sample-gis-records
             first
             :attribute-types
             (sort-by first))))

(rf/reg-sub ::compatible-gis-attribute-names
  :<- [::available-gis-attributes]
  (fn [attributes [_ prop-attr-type]]
    (->> (if (= prop-attr-type :property-attribute-template.type/text)
           attributes
           (filter #(= (second %) prop-attr-type) attributes))
         (map first))))

(defn new-template-section [tr]
  (let [{:property-attribute-template/keys [type names gis-attribute] :as data} (<sub [::new-template-data])
        valid?                                                                  (and type (not (i18n-model/blank? names)))
        group-id                                                                (<sub [::gas/group-id])
        sample-loading?                                                         (<sub [::gis-sample-loading?])
        gis-attrs                                                               (<sub [::available-gis-attributes])
        selected-gis-attr                                                       (p/find-first gis-attrs (comp (partial = gis-attribute) first))]
    [:section
     [:h4.mb-4 (tr [:property-mgmt-config.attrs/new-template])]
     [:div.flex.flex-wrap.gap-4.w-full.mb-4.items-end
      [:div.w-1-2.xl:w-1-3
       [ui-i18n/localized-string-edit
        {:id                  "new-template-names"
         :placeholder         (tr [:property-attribute-template/names])
         :label-text          (tr [:property-attribute-template/names])
         :strings             names
         :required            true
         :light               false
         :show-lang?          true
         :on-change           #(rf/dispatch-sync [::set-new-template-val :property-attribute-template/names %])
         :allowed-locales-sub ::gas/allowed-locales}]]
      [:div.unset-width-select
       [ui-select/select {:id           "new-template-type"
                          :required     true
                          :label-text   (tr [:property-attribute-template/type])
                          :values       property-model/attribute-template-types
                          :allow-empty? false
                          :on-change    (fn [new-type]
                                          (>evt [::set-new-template-val :property-attribute-template/type new-type])
                                          (when (and selected-gis-attr
                                                     (not= new-type :property-attribute-template.type/text)
                                                     (not= new-type (second selected-gis-attr)))
                                            ;; If attribute type is incompatible with GIS type, remove GIS type
                                            (>evt [::set-new-template-val
                                                   :property-attribute-template/gis-attribute
                                                   nil])))
                          :value        type
                          :val->str     (comp tr vector)}]]
      (if sample-loading?
        [:div.mb-2
         (cc/inline-loading {:description (tr [:property-mgmt-config.attrs/fetching])})]
        (when (<sub [::gis-attribute-link-supported?])
          [:div.unset-width-select
           [ui-select/select {:id           "new-template-gis-attr"
                              :label-text   (tr [:property-mgmt-config.attrs/link-to-gis])
                              :values       gis-attrs
                              :allow-empty? true
                              :on-change    (fn [[attr-name gis-type]]
                                              (>evt [::set-new-template-val
                                                     :property-attribute-template/gis-attribute
                                                     attr-name])
                                              (when (and type
                                                         (not= type gis-type)
                                                         (not= type :property-attribute-template.type/text))
                                                ;; If attribute type is incompatible with GIS type, set it to GIS type
                                                (>evt [::set-new-template-val
                                                       :property-attribute-template/type
                                                       gis-type])))
                              :value        selected-gis-attr
                              :val->str     #(str (first %) " (" (tr [(second %)]) ")")}]]))]
     [:div
      [ui-action-buttons/save-cancel-buttons
       {:on-cancel      #(>evt [::cancel-new-template])
        :on-save        #(>evt [::create-new-template group-id data])
        :save-disabled? (not valid?)
        :size           :small
        :tr             tr}]]]))

(defn template-heading
  [{:keys [tr lang saving?] {:property-attribute-template/keys [names] :db/keys [id]} :template} toggle-fn collapsed?]
  (let [unsaved-names (some-> (<sub [::ee/unsaved-for id])
                              :property-attribute-template/names)
        on-edit       #(rf/dispatch-sync [::ee/set-value id :property-attribute-template/names %1])]
    [:div.flex.items-center.gap-4
     (if unsaved-names
       [:<>
        [:div {:style {:min-width "24rem"}}
         [ui-i18n/localized-string-edit
          {:id                  (str "template-names-" id)
           :placeholder         (tr [:property-attribute-template/names])
           :label-text          (tr [:property-attribute-template/names])
           :hide-label          true
           :strings             unsaved-names
           :light               false
           :show-lang?          true
           :on-change           on-edit
           :allowed-locales-sub ::gas/allowed-locales}]]
        [ui-action-buttons/save-cancel-buttons
         {:on-cancel      #(>evt [::ee/cancel-changes id])
          :on-save        #(>evt [::save-template-edit id {:property-attribute-template/names unsaved-names}])
          :disabled?      saving?
          :save-disabled? (i18n-model/blank? unsaved-names)
          :size           :field
          :tr             tr}]]
       [:<>
        [:h4.cursor-pointer {:on-click toggle-fn}
         (i18n-model/get-text names lang)]
        (when-not collapsed?
          (cc/button {:kind     :ghost
                      :icon     i/pen
                      :size     :small
                      :on-click #(on-edit (i18n-model/strings-map names))}
                     (tr [:form.schema/rename])))])]))


(defn option-name-editor [{:keys [tr template-id id editor-values on-save hide-label]}]
  [:div.flex.gap-4.items-end
   [:div {:style {:min-width "24rem"}}
    [ui-i18n/localized-string-edit
     {:id                  (str/join "-" ["template-select-option" template-id id])
      :placeholder         (tr [:property-attribute-template-option/values])
      :label-text          (tr [:property-attribute-template-option/values])
      :strings             editor-values
      :light               false
      :show-lang?          true
      :hide-label          hide-label
      :on-change           #(>evt [::set-select-option-values template-id id %])
      :allowed-locales-sub ::gas/allowed-locales}]]
   [ui-action-buttons/save-cancel-buttons
    {:on-cancel      #(>evt [::set-select-option-values template-id id nil])
     :on-save        on-save
     :save-disabled? (i18n-model/blank? editor-values)
     :size           :field
     :tr             tr}]])

(defn dropdown-template-option-name
  [{:keys [tr lang template-id]} {:property-attribute-template-option/keys [values] :db/keys [id]}]
  (let [editor-values (<sub [::select-option-values template-id id])]
    (if editor-values
      [option-name-editor (util/mmap {:hide-label true
                                      :on-save    #(>evt [::edit-template-option
                                                          template-id
                                                          id
                                                          {:property-attribute-template-option/values editor-values}])}
                                     tr template-id id editor-values)]
      (i18n-model/get-text values lang))))

(defn dropdown-template-options
  [{:keys                                                            [tr lang]
    {:property-attribute-template/keys [options] template-id :db/id} :template}]
  (let [options (sort-by :ordered/order options)]
    [:div.border-t.border-solid.border-ui-gray.mt-6.pt-6
     [:h5 (tr [:property-mgmt-config.attrs/dropdown-options])]
     [:div.my-4 (tr [:property-mgmt-config.attrs/dropdown-options-info])]
     [:div.mb-4 {:style {:max-width "44rem"}}
      [ui-table/modern-responsive-table
       {:tr           tr
        :id           (str "template-select-options-" template-id)
        :headerless?  true
        :items        options
        :cols         [[:property-attribute-template-option/values
                        (fn [option]
                          [dropdown-template-option-name (util/mmap tr lang template-id) option])]]
        :on-reorder   (fn [from to]
                        (>evt [::reorder-template-option template-id (:db/id from) (:db/id to)]))
        :make-actions (fn [{:property-attribute-template-option/keys [values] :db/keys [id]}]
                        [{:title    (tr [:edit])
                          :on-click #(>evt [::set-select-option-values template-id id (i18n-model/strings-map values)])
                          :icon     i/pen}
                         {:title           (tr [:remove])
                          :on-click        #(>evt [::remove-template-option template-id id])
                          :icon            i/trash
                          :confirm?        true
                          :confirm-content (tr [:property-mgmt-config.attrs/remove-confirm])}])}]]
     (let [editor-values (<sub [::select-option-values template-id :new])
           set-values    #(>evt [::set-select-option-values template-id :new %])]
       (if (some? editor-values)
         [option-name-editor (util/mmap
                               {:hide-label false
                                :id         :new
                                :on-save    #(>evt [::create-new-template-option
                                                    template-id
                                                    {:property-attribute-template-option/values editor-values}])}
                               tr template-id editor-values)]
         (cc/button {:kind     :tertiary
                     :icon     i/plus
                     :size     :small
                     :on-click #(set-values {})}
                    (tr [:property-mgmt-config.attrs/add-dropdown-option]))))]))

(defn toggle-template-config
  [{:keys                                                   [tr lang]
    {:property-attribute-template/keys [toggle-false-labels
                                        toggle-true-labels]
     :db/keys                          [id]
     :as                               template}            :template}]
  (let [edit-false-labels (-> (<sub [::ee/unsaved-for id])
                              :property-attribute-template/toggle-false-labels)
        edit-true-labels  (-> (<sub [::ee/unsaved-for id])
                              :property-attribute-template/toggle-true-labels)]
    [:div.border-t.border-solid.border-ui-gray.mt-6.pt-6
     (if edit-false-labels
       [:div.flex.gap-4.items-end
        [:div
         [ui-i18n/localized-string-edit
          {:id                  (str "template-toggle-true-labels-" id)
           :placeholder         (tr [:property-attribute-template-toggle-default/true])
           :label-text          (tr [:property-attribute-template/toggle-true-labels])
           :strings             edit-true-labels
           :light               false
           :show-lang?          true
           :on-change           #(rf/dispatch-sync [::ee/set-value
                                                    id
                                                    :property-attribute-template/toggle-true-labels
                                                    %1])
           :allowed-locales-sub ::gas/allowed-locales}]]
        [:div
         [ui-i18n/localized-string-edit
          {:id                  (str "template-toggle-false-labels-" id)
           :placeholder         (tr [:property-attribute-template-toggle-default/false])
           :label-text          (tr [:property-attribute-template/toggle-false-labels])
           :strings             edit-false-labels
           :light               false
           :show-lang?          true
           :on-change           #(rf/dispatch-sync [::ee/set-value
                                                    id
                                                    :property-attribute-template/toggle-false-labels
                                                    %1])
           :allowed-locales-sub ::gas/allowed-locales}]]
        [ui-action-buttons/save-cancel-buttons
         {:on-cancel      (fn [_]
                            (>evt [::ee/cancel-changes id]))
          :on-save        #(>evt [::save-template-edit
                                  id
                                  {:property-attribute-template/toggle-false-labels edit-false-labels
                                   :property-attribute-template/toggle-true-labels  edit-true-labels}])
          :save-disabled? (some i18n-model/blank? [edit-false-labels edit-true-labels])
          :size           :field
          :tr             tr}]]
       [:div.flex.gap-4.items-end
        [:div
         [:div.bx--label (tr [:property-attribute-template/toggle-true-labels])]
         [:div.label-value (property-model/toggle-attribute-true-label template lang tr)]]
        [:div
         [:div.bx--label (tr [:property-attribute-template/toggle-false-labels])]
         [:div.label-value (property-model/toggle-attribute-false-label template lang tr)]]
        [:div
         (cc/button {:kind     :tertiary
                     :icon     i/pen
                     :size     :small
                     :on-click #(>evt [::ee/set-values
                                       id
                                       {:property-attribute-template/toggle-false-labels
                                        (or (i18n-model/strings-map toggle-false-labels) {})
                                        :property-attribute-template/toggle-true-labels
                                        (or (i18n-model/strings-map toggle-true-labels) {})}])}
                    (tr [:edit]))]])]))

(defn drag-and-drop-config [template-id]
  {:on-drag-start (fn [e]
                    (.setData (.-dataTransfer e) "from" template-id))
   :on-drag-over  #(.preventDefault %)
   :on-drag-enter #(.preventDefault %)
   :draggable     true
   :on-drop       (fn [e]
                    (let [from-id (-> (.-dataTransfer e)
                                      (.getData "from")
                                      parse-long)]
                      (>evt [::reorder-template from-id template-id])))})

(defn- ag-in-groups-fn [groups]
  (fn [ag-id]
    (let [group-set (set (map :db/id groups))]
      (some? (group-set ag-id)))))

(defn- visible-in-ws-col [{:property-attribute-template/keys [visible-in-groups] template-id :db/id}]
  (let [visible-fn? (ag-in-groups-fn visible-in-groups)]
    [:property-mgmt-config.attrs/visible-in-ws
     (fn [{ag-id :db/id}]
       (cc/checkbox
         {:id         (str "visible-in-ws-checkbox-" template-id "-" ag-id)
          :label-text ""
          :checked    (visible-fn? ag-id)
          :on-change  #(>evt [::set-group-attribute-value template-id :property-attribute-template/visible-in-groups ag-id %])}))]))

(defn- pinned-in-ws-col [{:property-attribute-template/keys [pinned-in-groups visible-in-groups] template-id :db/id}]
  (let [visible-fn? (ag-in-groups-fn visible-in-groups)
        pinned-fn?  (ag-in-groups-fn pinned-in-groups)]
    [:property-mgmt-config.attrs/pin-in-ws
     (fn [{ag-id :db/id}]
       (cc/checkbox
         {:id         (str "pin-in-ws-checkbox-" template-id "-" ag-id)
          :label-text ""
          :disabled   (not (visible-fn? ag-id))
          :checked    (and (visible-fn? ag-id)
                           (pinned-fn? ag-id))
          :on-change  #(>evt [::set-group-attribute-value template-id :property-attribute-template/pinned-in-groups ag-id %])}))]))

(defn- temple-visibility-checkbox-table [tr template]
  [:div.border-t.border-solid.border-ui-gray.mt-6.pt-6
   [:h5 (tr [:property-mgmt-config.attrs/visibility-settings])]
   [:div.my-4
    [ui-table/modern-responsive-table
     {:id    (str "template-visibility-checkbox-table-" (:db/id template))
      :tr    tr
      :cols  [[:property-mgmt-config.attrs/module
               :permit-type]
              (visible-in-ws-col template)
              (pinned-in-ws-col template)]
      :items (<sub [::authority-group-ids+pts])}]
    [ui/instructions
     {:tr         tr
      :paragraphs [:property-mgmt-config.attrs.help.checkbox-table/display-workspace
                   :property-mgmt-config.attrs.help.checkbox-table/pinning-prevent-hidden
                   :property-mgmt-config.attrs.help.checkbox-table/pinning-availability]}]]])

(defn- toggle [{:keys [tr id data-cy disabled? label-kw toggled on-toggle instructions]}]
  [:div.border-t.border-solid.border-ui-gray.mt-6.pt-6
   [:div.my-4
    [:div.flex.items-center.leading-tight.mb-2
     [:span.mx-2 (tr [label-kw])]
     (cc/toggle (util/mmap {:labelA     (tr [:false])
                            :labelB     (tr [:true])
                            :disabled   (boolean disabled?)
                            :class-name "unlabeled-toggle"}
                           id
                           data-cy
                           toggled
                           on-toggle))]
    [ui/instructions
     {:tr         tr
      :paragraphs instructions}]]])

(defn- confidential-toggle [tr {:property-attribute-template/keys [visibility] template-id :db/id}]
  [toggle
   (util/mmap {:id           (str "confidential-toggle-" template-id)
               :data-cy      "confidential-toggle"
               :label-kw     :property-mgmt-config.attrs/confidential-toggle
               :toggled      (= visibility :property-attribute-template.visibility/write-authority)
               :on-toggle    (fn [toggled-on?]
                               (let [new-visibility (if toggled-on?
                                                      :property-attribute-template.visibility/write-authority
                                                      :property-attribute-template.visibility/read-authority)]
                                 (>evt [::set-attribute-value template-id :property-attribute-template/visibility new-visibility])))
               :instructions [:property-mgmt-config.attrs.help.confidential-toggle/prevent-public
                              :property-mgmt-config.attrs.help.confidential-toggle/prevent-non-visible]}
              tr)])

(defn- public-toggle [tr {:property-attribute-template/keys [visibility] template-id :db/id}]
  [toggle
   (util/mmap {:id           (str "public-toggle-" template-id)
               :data-cy      "public-toggle"
               :label-kw     :property-mgmt-config.attrs/public-toggle
               :disabled?    (= visibility :property-attribute-template.visibility/write-authority)
               :toggled      (= visibility :property-attribute-template.visibility/public)
               :on-toggle    (fn [toggled-on?]
                               (let [new-visibility (if toggled-on?
                                                      :property-attribute-template.visibility/public
                                                      :property-attribute-template.visibility/read-authority)]
                                 (>evt [::set-attribute-value template-id :property-attribute-template/visibility new-visibility])))
               :instructions [:property-mgmt-config.attrs.help.public-toggle/visible-workspace-module
                              :property-mgmt-config.attrs.help.public-toggle/visible-property-view
                              :property-mgmt-config.attrs.help.public-toggle/unavailable-with-confidential]}
              tr)])

(defn- critical-toggle [tr {:property-attribute-template/keys [critical?] template-id :db/id}]
  [toggle
   (util/mmap {:id           (str "critical-toggle-" template-id)
               :data-cy      "critical-toggle"
               :label-kw     :property-mgmt-config.attrs/critical-toggle
               :toggled      (or critical? false)
               :on-toggle    #(>evt [::set-attribute-value template-id :property-attribute-template/critical? %])
               :instructions [:property-mgmt-config.attrs.help.critical-toggle/highlighted]}
              tr)])

(defn- gis-overwrite-toggle [tr {:property-attribute-template/keys [allow-gis-overwrite? gis-attribute] template-id :db/id}]
  (when gis-attribute
    [toggle
     (util/mmap {:id           (str "gis-overwrite-toggle-" template-id)
                 :data-cy      "gis-overwrite-toggle"
                 :label-kw     :property-attribute-template/allow-gis-overwrite?
                 :toggled      (or allow-gis-overwrite? false)
                 :on-toggle    #(>evt [::set-attribute-value template-id :property-attribute-template/allow-gis-overwrite? %])
                 :instructions [:property-mgmt-config.attrs.help.gis-overwrite-toggle/allow-overwrite]}
                tr)]))

(defn visibility-configurator [tr template]
  [:<>
   [temple-visibility-checkbox-table tr template]
   [confidential-toggle tr template]
   [public-toggle tr template]
   [critical-toggle tr template]
   [gis-overwrite-toggle tr template]])

(def attr-type-compatible-with-gis?
  #{:property-attribute-template.type/text
    :property-attribute-template.type/integer
    :property-attribute-template.type/date
    :property-attribute-template.type/decimal})

(defn single-template-section
  [{:keys                                                                               [tr reordering? group-id]
    {:property-attribute-template/keys [type gis-attribute] :db/keys [id] :as template} :template}]
  (let [lang             (<sub [:language])
        saving?          (<sub [:comm/command-processing? :group/edit-property-attribute-template])
        values           (if gis-attribute
                           [type] ;; If GIS attribute is set, type cannot be changed
                           (->> (get property-model/compatible-template-types type)
                                (concat [type])
                                distinct))
        all-gis-attrs    (<sub [::available-gis-attributes])
        sample-loading?  (<sub [::gis-sample-loading?])
        gis-link?        (<sub [::gis-attribute-link-supported?])
        compat-gis-attrs (<sub [::compatible-gis-attribute-names type])]
    [section/section
     (str "property-attribute-template-" id)
     {:initially-collapsed? true
      :tr                   tr
      :class                "compact"
      :heading-class        "normal-case"
      :heading-component    (partial template-heading (util/mmap tr lang template saving?))
      :dnd-config           (when reordering?
                              (merge (drag-and-drop-config id)
                                     {:class "cursor-move"}))}
     nil
     [:div.pb-4
      [:div.flex.gap-8
       (if (= 1 (count values))
         [:div
          [:div.bx--label (tr [:property-attribute-template/type])]
          [:div.label-value (tr [type])]]
         [:div
          [ui-select/select {:id           (str "template-type-" id)
                             :class        "unset-width-select"
                             :label-text   (tr [:property-attribute-template/type])
                             :values       values
                             :allow-empty? false
                             :on-change    #(>evt [::save-template-edit id {:property-attribute-template/type %}])
                             :value        type
                             :val->str     (comp tr vector)
                             :disabled     (or (= 1 (count values)) saving?)}]])
       (when (or gis-attribute (seq compat-gis-attrs))
         (if (seq compat-gis-attrs)
           [ui-select/select {:id           (str "template-gis-attr" id)
                              :label-text   (tr [:property-mgmt-config.attrs/link-to-gis])
                              :values       (->> (concat (when gis-attribute [gis-attribute])
                                                         compat-gis-attrs)
                                                 distinct)
                              :allow-empty? true
                              :on-change    #(>evt [::save-template-edit
                                                    id
                                                    {:property-attribute-template/gis-attribute %}])
                              :value        gis-attribute
                              :val->str     identity}]
           [:div
            [:div.bx--label (tr [:property-mgmt-config.attrs/link-to-gis])]
            [:div.label-value gis-attribute]]))
       (when (and gis-link? (empty? all-gis-attrs) (attr-type-compatible-with-gis? type))
         [:div.flex.items-center {:style {:height "64px"}}
          (if sample-loading?
            (cc/inline-loading {:description (tr [:property-mgmt-config.attrs/fetching])})
            (cc/button {:kind     :tertiary
                        :size     :small
                        :on-click #(>evt [::fetch-sample-gis-records group-id false])}
                       (tr [:property-mgmt-config.attrs/fetch-gis-attributes])))])]
      (case type
        :property-attribute-template.type/select [dropdown-template-options (util/mmap tr lang template)]
        :property-attribute-template.type/toggle [toggle-template-config (util/mmap tr lang template)]
        nil)
      [visibility-configurator tr template]
      [:div.w-full.flex.items-end.justify-end.border-t.border-solid.border-ui-gray.mt-6.pt-6.gap-4
       (when (du/in-state? :property-attribute-template.state/disabled template)
         [:div
          [ui/modal-confirmation-button
           {:id                  (str "remove-template-" id)
            :tr                  tr
            :modal-title         (tr [:property-mgmt-config.attrs/template-remove-title])
            :trigger-button-opts {:kind             :danger
                                  :size             :small
                                  :icon             i/trash
                                  :icon-description (tr [:admin.api-keys/remove-redirect-uri])}
            :trigger-button-text (tr [:property-mgmt-config.attrs/remove-template])
            :on-yes-click        #(>evt [::remove-template id])}
           (tr [:property-mgmt-config.attrs/template-remove-info]
               [(property-model/attribute-template-name template lang)])]])
       [:div.mr-8
        (cc/toggle {:toggled    (du/in-state? :property-attribute-template.state/enabled template)
                    :id         (str "property-attribute-template-enabled" id)
                    :label-text (tr [:property-mgmt-config.attrs/state-label])
                    :labelA     (tr [:property-mgmt-config.attrs/state-disabled])
                    :labelB     (tr [:property-mgmt-config.attrs/state-enabled])
                    :on-toggle  (fn [enabled?]
                                  (>evt [::save-template-edit
                                         id
                                         {:domain/state (if enabled?
                                                          :property-attribute-template.state/enabled
                                                          :property-attribute-template.state/disabled)}]))})]]]]))

(defn sample-records-display [{:keys [tr samples group-id]}]
  [:div.w-full
   [gis-search-config/sample-records-display-generic
    (util/mmap {:server-id                "gis-attr-config"
                :map-initially-collapsed? true
                :map-click-evt            (fn [^js e]
                                            (>evt [::fetch-sample-gis-records
                                                   group-id
                                                   false
                                                   (.-coordinate e)]))}
               tr
               samples)]])

(defn sample-record-modal [{:keys [tr group-id samples]}]
  (let [open? (<sub [::sample-modal-open?])]
    (when (and open? (seq samples))
      [ui-modal/composed-input-modal
       {:open    open?
        :data-cy "gis-sample-modal"
        :key     "gis-sample-modal"}
       (cc/modal-header
         {:button-on-click #(>evt [::set-sample-modal-open? false])}
         [:h2 (tr [:property-mgmt-config.attrs/gis-sample])])
       (cc/modal-body
         [sample-records-display (util/mmap tr samples group-id)])
       (cc/modal-footer
         {:secondary-button-text (tr [:close])
          :on-request-close      #(>evt [::set-sample-modal-open? false])})])))

(defn tab-content []
  (let [tr                (<sub [::gas/group-tr])
        group-id          (<sub [::gas/group-id])
        new-attr-visible? (some? (<sub [::new-template-data]))
        templates         (<sub [::attribute-templates])
        reordering?       (<sub [::reordering?])
        gis-link?         (<sub [::gis-attribute-link-supported?])
        samples           (<sub [::sample-gis-records])]
    [:div.property-config-attributes
     [:div.flex.justify-end
      [ui-i18n/edit-language-selector
       {:class               "-mt-16 mb-4"
        :allowed-locales-sub ::gas/allowed-locales
        :label-tr-key        :property-mgmt-config.attrs/language-picker-label
        :light               true}]]
     (when (seq templates)
       [:div.flex.items-center.justify-between.w-full.mb-4
        [:div (tr [:property-mgmt-config.attrs/order-info])]
        [:div.flex.gap-2
         (if (<sub [::gis-sample-loading?])
           (cc/inline-loading {:description (tr [:property-mgmt-config.attrs/fetching])})
           (when gis-link?
             (cc/button {:kind     :tertiary
                         :icon     i/map
                         :size     :small
                         :on-click #(if (seq samples)
                                      (>evt [::set-sample-modal-open? true])
                                      (>evt [::fetch-sample-gis-records group-id true]))}
                        (if (seq samples)
                          (tr [:property-mgmt-config.attrs/show-gis-sample])
                          (tr [:property-mgmt-config.attrs/fetch-gis-sample])))))
         (cc/button {:kind     (if reordering? :primary :tertiary)
                     :icon     (when reordering? i/remove)
                     :size     :small
                     :on-click #(>evt [::set-reordering (not reordering?)])}
                    (tr [:property-mgmt-config.attrs/reorder]))]])
     [sample-record-modal (util/mmap tr group-id samples)]
     (for-frag [template templates]
       [single-template-section (util/mmap tr template reordering? group-id)])
     (when new-attr-visible?
       [new-template-section tr])
     [ui-placeholder-button/placeholder-button
      {:icon     i/plus
       :bg-class "bg-transparent mt-4"
       :on-click #(>evt [::init-new-template group-id (and gis-link? (empty? samples))])
       :title    (tr [:property-mgmt-config.attrs/new-template])}]]))
